<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card>
      <v-card-title>ユーザ詳細</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="8">
            <div class="overline">
              氏名
            </div>
            <h4>{{ user.name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8">
            <div class="overline">
              メールアドレス
            </div>
            <h4>{{ user.email }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8">
            <div class="overline">
              ログインID
            </div>
            <h4>{{ user.login_id }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              ロール
            </div>
            <h4>{{ user.role | admin_user_role }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              最終ログイン日時
            </div>
            <h4>{{ user.last_login_at | unix_datetime_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              作成日時
            </div>
            <h4>{{ user.created_at | unix_datetime_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              更新日時
            </div>
            <h4>{{ user.updated_at | unix_datetime_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          @click="editButtonClickEvent"
        >
          編集
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>

import Confirm from '../../../components/Confirm'
import { mapActions} from 'vuex'

export default {
  name: 'AdminUserShow',
  components: {
    Confirm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: 'ユーザ一覧', disabled: false, to: '/admin/users', exact: true },
        { text: 'ユーザ詳細', disabled: true, to: '' },
      ],
      user: {}
    }
  },
  created() {
    this.fetchUser({ id: this.$route.params.id }).then((content) => {
      this.user = content
    })
  },
  methods: {
    ...mapActions('AdminUser', {
      fetchUser: 'show',
      deleteUser: 'destroy',
    }),
    cancelButtonClickEvent () {
      this.$router.push({name: 'AdminUsers'})
    },
    editButtonClickEvent () {
      this.$router.push({name: 'AdminUserEdit', params: { id: String(this.user.id) }})
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteUser({id: this.user.id }).then(() =>{
            this.$router.push({name: 'AdminUsers'})
          })
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
</style>
